<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Basic Christianity</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<p class="OT" id="for"><a id="page_vii"></a><a href="#/xhtml/Contents#for1">Foreword</a></p>
<p class="Bodyflush"><span class="dropcap">T</span>here are a few landmark books that everyone in the world should read. This is one of the rare few.</p>
<p class="Body">In the twenty-first century, you cannot afford to ignore this book! Whether you are a skeptic, raised in another faith, a spiritual seeker, or a Christian believer, you need to know why 2.3 billion people call themselves “Christians.” You need to know what they believe and why they believe it.</p>
<p class="Body">This book is especially essential for leaders in business, government, academics, media, entertainment, journalism, and other fields that work directly with people. To be able to have an intelligent conversation with one-third of our world’s population, you need to understand their worldview.</p>
<p class="Body">John Stott’s <i>Basic Christianity</i> is a classic introduction to the faith that has transformed billions of lives.</p>
<p class="Right1">R<span class="small">ICK</span> W<span class="small">ARREN</span><i><br/>Pastor<br/>Saddleback Church</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Foreword.vue?240afe5c